<template>
  <div class="border-svg">
    <div class="title">
        <slot name="title"><img style="margin-right: 10px;" src="@/assets/titleicon.svg" /> 近7日用户增长</slot>
    </div>
    <slot name="tabledata"></slot>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.border-svg {
    background-image: url(@/assets/border.svg);
    background-size: 100% 100%;
    padding: 15px;
    box-sizing: border-box;
}
.title {
    color: white;
    display: flex;
    flex-flow: row;
    font-size: 20px;
}
</style>